/**
 * Transforms a float to a currency string
 *
 * @param price
 * @returns {string}
 */
export const moneyFormat = price => {
  const formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });

  return formatter.format(price);
};
